import { Component, OnInit } from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';

@Component({
    selector: 'app-modal-alerta',
    templateUrl: './modal-alerta.component.html',
    styleUrls: ['./modal-alerta.component.scss'],
})
export class ModalAlertaComponent {

    public titulo = '';
    public subTitulo = '';
    public txtBtnAfirmacao = 'SIM';
    public txtBtnNegacao = 'NÃO';
    public habilitarBtnNegacao = true;
    public height = '100px';
    public disableFixedHeight = false;
    public lines = [];
    public confirmText = "";


    constructor(
        private modalController: ModalController,
        private navParams: NavParams
    ) {
        const parametros = this.navParams.get('parametros');

        if (parametros) {
            if (parametros.titulo) {
                this.titulo = parametros.titulo;
            }

            if (parametros.subTitulo) {
                this.subTitulo = parametros.subTitulo;
            }

            if (parametros.txtBtnAfirmacao) {
                this.txtBtnAfirmacao = parametros.txtBtnAfirmacao;
            }

            if (parametros.txtBtnNegacao) {
                this.txtBtnNegacao = parametros.txtBtnNegacao;
            }

            if (parametros.habilitarBtnNegacao === false) {
                this.habilitarBtnNegacao = false;
            }

            if (parametros.modalHeight) {
                this.height = parametros.modalHeight;
            }

            if (parametros.disableFixedHeight) {
                this.disableFixedHeight = parametros.disableFixedHeight;
            }

            if(parametros.lines) {
                this.lines = parametros.lines
            }

            if(parametros.confirmText) {
                this.confirmText = parametros.confirmText
            }
        }
    }

    async fechar(opcao) {
        await this.modalController.dismiss(opcao);
    }
}
